import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { toast } from 'react-hot-toast';
import { getStandardizedSignatures } from '../../utils/formHelpers';
import { useApplicationFormLogic } from '../../hooks/useApplicationFormLogic';
import { request } from '../../utils/api';
import EvaluationFormHeader from "../EvaluationNew/components/EvaluationFormHeader";
import { governmentFormSchema } from './application.validation';
import PropTypes from 'prop-types';
import CloseButton from '../../components/Application/CloseButton';
import { getLocalSystemDate, parseIsoDateToMDYUS } from '../../utils/dateUtils';
import { buildPayloadWithIsoDates } from '../../utils/applicationFormPayload';

const W9Form = ({ positionName, onSave, onClose }) => {
  const [w9Id, setW9Id] = useState(null);
  const [currentStatus, setCurrentStatus] = useState("");


  const methods = useForm({
    resolver: zodResolver(governmentFormSchema),
    defaultValues: {
      tenantId: undefined,
      userId: undefined,
      applicantName: "",
      applicantSignature: "",
      applicantSignedAt: parseIsoDateToMDYUS(getLocalSystemDate()),
      reviewedBySignature: "",
      reviewedBySignedAt: "",
      reviewedBySignedBy: ""
    },
    mode: "onChange"
  });
  const onSubmit = async (data, flag = 'send_to_office', additionalData = {}) => {
    const actualFlag = typeof flag === 'string' ? flag : 'send_to_office';
    try {
      const payload = buildPayloadWithIsoDates(
        data,
        additionalData,
        ['applicantSignedAt', 'reviewedBySignedAt'],
        { flag: actualFlag }
      );
      payload.positionAppliedFor = positionName;

      // Handle To Be Corrected comments
      const finalComments = additionalData?.comments || data?.comments || methods.getValues("comments");
      if (finalComments) {
        payload.comments = finalComments;
      }

      const method = w9Id ? 'PUT' : 'POST';
      const url = w9Id ? `/w9-forms/${w9Id}` : '/w9-forms';

      const response = await request(url, {
        method,
        body: JSON.stringify(payload)
      });

      if (response.status === 1) {
        toast.success(response.message || "W-9 Form processed successfully!");
        closeForm();
      } else {
        toast.error(response.message || "Failed to process W-9 Form");
      }
    } catch (error) {
      console.error("Error submitting W-9:", error);
      toast.error("Failed to submit form");
    }
  };

  const {
    targetUserId,
    user: currentUserData,
    isAdmin,
    closeForm,
  } = useApplicationFormLogic({
    methods,
    applicantNameField: "applicantName",
    applicantSignatureField: "applicantSignature",
    applicantSignatureDateField: "applicantSignedAt",
    adminSignatureField: "reviewedBySignature",
    adminSignatureDateField: "reviewedBySignedAt",
    onClose,
    onSubmit,
    currentStatus
  });

  const { reset } = methods;

  useEffect(() => {
    const fetchData = async () => {
      if (!targetUserId || !currentUserData) return;
      try {
        const response = await request(`/w9-forms/${targetUserId}`);
        if (response.status === 1 && response.result) {
          const data = response.result.w9Form || response.result;
          setW9Id(data.id);
          setCurrentStatus(data.status || "");
          reset({
            ...data,
            applicantName: data.applicantName || "",
            applicantSignature: data.applicantSignature || "",
            ...getStandardizedSignatures(data, isAdmin)
          });
        }
      } catch (error) {
        console.error("Error fetching W9 data:", error);
      }
    };
    fetchData();
  }, [targetUserId, reset, currentUserData, isAdmin]);

  return (
    <div className="max-w-6xl mx-auto bg-white shadow-xl rounded-2xl my-8">
      <CloseButton onClose={closeForm} />
      <EvaluationFormHeader
        title="W-9 Form"
        subtitle="Request for Taxpayer Identification Number and Certification"
      />

      <div className="p-8">
        {/* PDF Viewer */}
        <div className="mb-8 border rounded-xl overflow-hidden bg-gray-100 shadow-sm h-[800px]">
          <iframe
            src="/W9.pdf#toolbar=1"
            className="w-full h-full"
            title="W-9 Form"
          />
        </div>
        {/* 
        <FormProvider {...methods}>
          <form className="space-y-8">
            <ApplicationFormFooter
              page={1}
              totalPages={1}
              methods={methods}
              onSave={handleSave}
              onSubmit={(data, status, extra) => onSubmit(data, status || 'send_to_office', extra)}
              onStatusUpdate={handleStatusAction}
              isSignatureModalOpen={isSignatureModalOpen}
              openSignatureModal={openSignatureModal}
              closeSignatureModal={closeSignatureModal}
              handleSignatureApply={handleSignatureApply}
              signerName={signerName}
              applicantName={watch('applicantName') || ""}
              applicantSignature={watch('applicantSignature')}
              applicantSignedAt={watch('applicantSignedAt')}
              reviewedBySignedBy={watch('reviewedBySignedBy') || signerName}
              reviewedBySignature={watch('reviewedBySignature')}
              reviewedBySignedAt={watch('reviewedBySignedAt')}
              showCertification={false}
              isReadOnly={isReadOnly}
              onClose={closeForm}
              currentStatus={currentStatus}
            />

          </form>
        </FormProvider> */}
      </div>

    </div>
  );
};

W9Form.propTypes = {
  positionName: PropTypes.string,
  onSave: PropTypes.func,
  onClose: PropTypes.func
};

export default W9Form;

